import type { ReactElement, ReactNode } from "react";
import { createContext, createElement, useContext } from "react";

type ChatContextValue = {
	isChatOpen: boolean;
};

const ChatContext = createContext<ChatContextValue>({
	isChatOpen: false
});

type ProviderProps = {
	children: ReactNode;
	isChatOpen: boolean;
};

export function ChatContextProvider({
	isChatOpen,
	children
}: ProviderProps): ReactElement {
	return createElement(
		ChatContext.Provider,
		{ value: { isChatOpen } },
		children
	);
}

export const useChatContext = (): ChatContextValue => useContext(ChatContext);
